module.exports = __webpack_public_path__ + "static/img/2层(1).90ac133.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/2层(1).png
// module id = 3cPv
// module chunks = 0